export interface BillcheckDetails {
  firstName?: string;
  lastName?: string;
  gender?: string;
  email?: string;
  balanceAmount?: number;
  balanceType?: BillCheckBalanceType;
  deliveryDate?: string;
  accountingPeriodFrom?: string;
  accountingPeriodTo?: string;
}

export enum BillCheckBalanceType {
  Credit = 'CREDIT',
  AdditionalPayment = 'ADDITIONAL_PAYMENT',
}

export enum BillCheckDocumentType {
  RentalContract = 'RENTAL_CONTRACT',
  OperationalStatement = 'OPERATIONAL_STATEMENT',
}

export enum BillCheckGender {
  Male = 'MALE',
  Female = 'FEMALE',
  Other = 'OTHER',
}

export interface Documents {
  rentalContractFileNames: string[];
  operationalStatementFileNames: string[];
}

export interface StartBillCheckResponse {
  billCheckFlowId: string;
}

export interface UploadUrlRes {
  signedUploadUrl: string;
  id: string;
  fileName: string;
}
[];

export interface DocumentUrlsResponse {
  rentalContractUploadUrls: UploadUrlRes[];
  rentalContractFailedUploadUrls: string[];
  operationalStatementUploadUrls: UploadUrlRes[];
  operationalStatementFailedUploadUrls: string[];
}

export interface SubmitBillCheckReq {
  rentalContract: {
    fileName: string;
    id: string;
  }[];
  operationalStatement: {
    fileName: string;
    id: string;
  }[];
}

export enum BILLCHECK_V3_STATUS {
  STARTED = 'STARTED',
  PROCESSING = 'PROCESSING',
  USER_ACTION = 'USER_ACTION',
  FINISHED = 'FINISHED',
  ANNULLED = 'ANNULLED',
}

export interface BillcheckV3 {
  billCheckStatus: BILLCHECK_V3_STATUS;
  billCheckFlowId: string;
  modifiedAt: number;
  ticketId?: string;
  isPremium: boolean;
}

export interface IBillchecksStatusV3Res {
  billChecks: BillcheckV3[];
  canStartNewBillCheckFlow: boolean;
  plusProduct: boolean;
}

export type BillcheckV3State = IBillchecksStatusV3Res;
